export default {
  lang: {
    reset: '重置',
    search: '篩選',
    expand: '展開',
    collapse: '收起',
  },
};
